import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { submitOnboardingDocuments } from 'commons/service/client/application'

export const useSubmitOnboardingDocuments: WriteHook<{ id: number }, unknown> = (opts) =>
  useMutationManager<{ id: number }, unknown>(submitOnboardingDocuments, opts)
